import axios from "axios";
import { baseDomain } from "../../../../../Constants/apiRoutes";

const BASE_URL_V1 = `${baseDomain}/v2`;

export const createMilestoneApi = (data) => {
  return axios.post(`${BASE_URL_V1}/milestone`, data);
};

export const updateMilestoneApi = (id, data) => {
  return axios.put(`${BASE_URL_V1}/milestone/${id}`, data);
};

export const getMilestoneByIdApi = (id) => {
  return axios.get(`${BASE_URL_V1}/milestone/${id}`);
};

export const getAllMilestonesApi = (page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V1}/milestone?page=${page}&limit=${limit}`);
};

export const getMilestoneBinApi = (page = 1, limit = 10) => {
  return axios.get(`${BASE_URL_V1}/milestone/bin/list?page=${page}&limit=${limit}`);
};

export const deleteMilestoneApi = (id) => {
  return axios.delete(`${BASE_URL_V1}/milestone/${id}`);
};

export const restoreMilestoneApi = (id) => {
  return axios.put(`${BASE_URL_V1}/milestone/restore/${id}`);
};
